// extracted by mini-css-extract-plugin
export var component = "RSSFeed-module--component--405f4";
export var fadePop = "RSSFeed-module--fade-pop--796fd";
export var flex = "RSSFeed-module--flex--9dfb5";
export var growHeightIn = "RSSFeed-module--grow-height-in--7a0a7";
export var icon = "RSSFeed-module--icon--64c21";
export var list_item = "RSSFeed-module--list_item--bfa42";